import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
	},
};
